import { useCallback } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEPS } from '../../../utils/steps';

const styles = {
  banner: css`
    border-color: ${theme.colors.secondary.seaweed40};
    background: ${theme.colors.secondary.seaweed5};
    color: ${theme.colors.black};
    display: flex;
    align-items: center;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2, 3)};
    border-radius: ${theme.borderRadius.medium};
    border: solid 1px ${theme.colors.secondary.seaweed40};
    border-left-width: 4px;
  `,
  icon: {
    height: theme.spacing(3),
    width: theme.spacing(3),
    color: theme.colors.secondary.seaweed40,
  },
  content: css`
    font-size: ${theme.font.size.medium};
    flex: 1;
  `,
};
export const CareCreditPrequalifyBanner = () => {
  const { t } = useTranslation('payments');

  const {
    multiStep: { goNextStep },
  } = useCollectPaymentMultiContext();

  const onClick = useCallback(() => {
    goNextStep({
      orStep: PAYMENT_MULTI_STEPS.careCreditEnroll,
    });
  }, [goNextStep]);

  return (
    <div css={styles.banner}>
      <div>
        <Icon name='care-credit' css={styles.icon} />
      </div>
      <div css={styles.content}>{t('Check to see if this customer qualifies for CareCredit financing.')}</div>
      <div>
        <Button variant='tertiary' onClick={onClick}>
          {t('Check Now')}
        </Button>
      </div>
    </div>
  );
};
